import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedColaboradorComponent {
  colaborador
  desplegable
  desplegar = false
  elegir = false
  idColaborador
  idProyecto
  onSelect
  proyecto = {}
  proyectos
  soloLectura
  viaticoId
  yo

  constructor (ViaticosUsuarioColaboradorService, ViaticosUsuarioProyectosService, ViaticosColaboradorService, $q) {
    this.ViaticosUsuarioColaboradorService = ViaticosUsuarioColaboradorService
    this.ViaticosUsuarioProyectosService = ViaticosUsuarioProyectosService
    this.ViaticosColaboradorService = ViaticosColaboradorService
    this.$q = $q
  }

  $onInit () {
    this.promise = this.ViaticosUsuarioProyectosService.get()
      .then(({data}) => {
        this.proyectos = data.filter((item) => item.total_empleados > 0)
        return this.idProyecto && this.idColaborador
          ? this.getInformacion(this.idProyecto, this.idColaborador)
          : this.ViaticosUsuarioColaboradorService.get()
            .then(({data}) => {
              this.yo = Object.assign({}, data)

              /*const existe = this.proyectos.some((item) => item.id === this.yo.id_proyecto)
              if (!existe) {
                this.proyectos = this.proyectos.concat({
                  cliente: this.yo.empresa,
                  cliente_rfc: this.yo.empresa_rfc,
                  estado: null,
                  id: this.yo.id_proyecto,
                  nombre: this.yo.empresa,
                  total_empleados: 1,
                  total_responsables: 0,
                })
              }*/

              if (!this.proyectos.length) {
                this.colaborador = Object.assign({}, data)
                this.onSelect({$event: {detail: {colaborador: this.colaborador, proyecto: this.proyecto}}})
              }
            })
      })
  }

  elegirOtro () {
    this.elegir = true
    this.onSelect({$event: {detail: {colaborador: {}, proyecto: {}}}})
  }

  elegirme () {
    this.elegir = false
    this.colaborador = Object.assign({}, this.yo)
    this.proyecto = this.proyectos.find((proyecto) => proyecto.id === this.colaborador.id_proyecto)
    this.onSelect({$event: {detail: {colaborador: this.colaborador, proyecto: this.proyecto}}})
  }

  getInformacion (idProyecto, idColaborador) {
    return this.ViaticosColaboradorService.get(idProyecto, idColaborador)
      .then(({data}) => {
        this.colaborador = data
        this.proyecto = this.proyectos.find((proyecto) => proyecto.id === this.colaborador.id_proyecto)
        this.onSelect({$event: {detail: {colaborador: this.colaborador, proyecto: this.proyecto}}})
      })
  }

  setColaborador (data) {
    if (!data.id_proyecto || !data.id_colaborador) {
      this.elegir = false
    } else {
      this.promise = this.ViaticosColaboradorService.get(data.id_proyecto, data.id_colaborador)
        .then(({data}) => {
          this.colaborador = data
          this.proyecto = this.proyectos.find((proyecto) => proyecto.id === this.colaborador.id_proyecto)
          this.elegir = false
          this.onSelect({$event: {detail: {colaborador: this.colaborador, proyecto: this.proyecto}}})
        })
    }
  }
}

module.component('viaticosSharedColaborador', {
  controller: ViaticosSharedColaboradorComponent,
  template,
  bindings: {
    colaborador: '<',
    desplegable: '<',
    idColaborador: '<',
    idProyecto: '<',
    soloLectura: '<',
    viaticoId: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/colaborador/component.js